import type { OnboardingTourStepOption, SupportedOnboardingTourStep } from 'models';
import { useMemo } from 'react';

export const useSupportedOnboardingTourStep = ({
  step,
  steps,
}: {
  step?: OnboardingTourStepOption;
  steps: SupportedOnboardingTourStep[];
}) => useMemo(() => steps.find((remainingStep) => remainingStep.step === step), [step, steps]);
